import React from 'react';
import ReactDOM from 'react-dom';
import PartyMessage from './party_message.js.jsx'
export default class PartyMessages extends React.Component {

  loadPartyMessagesFromServer = () => {
    var url = this.props.url;
    $.ajax({
      url: url,
      dataType: 'json',
      success: function(data) {
        this.setState({data: data.party_messages});
      }.bind(this),
      error: function(xhr, status, err) {
        console.error(url, status, err.toString());
      }.bind(this)
    });
  }

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      message_count: 0
    };
    this.pMessages = React.createRef();
  }

  componentDidMount() {
    this.loadPartyMessagesFromServer();
    setInterval(this.loadPartyMessagesFromServer, this.props.pollInterval);
  }

  componentDidUpdate() {
    // Only scroll to the bottom initially and if messages count increases
    if(this.state.data.length > this.state.message_count) {
      $("#party-chat-panel").each(function() {
	      $(this).scrollTop(this.scrollHeight)
      });
      this.state.message_count = this.state.data.length;
    }
  }

  render() {
    var locale = this.props.locale
    var state = this;
    if (this.state.data.length > 0) {
      var partyMessageNodes = this.state.data.map(function(party_message) {
        return (
          <PartyMessage data={party_message} locale={locale} key={party_message.id} ref={state.pMessages}/>
        );
      });
      return (
        <ul className="chat" ref={state.pMessages}>
          {partyMessageNodes}
        </ul>
      );
    } else {
      return (
        <ul className="chat" ref={state.pMessages}>
          <li className="left clearfix">{I18n.components.party_messages.no_messages}</li>
        </ul>
      );
    }
  }
}
